import { render, staticRenderFns } from "./AppServiceListCreateOrEditPackages.vue?vue&type=template&id=555c0086&"
import script from "./AppServiceListCreateOrEditPackages.vue?vue&type=script&lang=js&"
export * from "./AppServiceListCreateOrEditPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports